import { Component, OnInit, Input, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewBaseComponent } from '../../misc/view-base/view-base.component';
import { ComponentStatus } from '../../../models/enums/componentStatus';
import { Reservierung } from '../../../models/reservierung';
import { StartupService } from '../../../services/startup.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-barcode-dialog',
  templateUrl: './barcode-dialog.component.html'
})
export class BarcodeDialogComponent extends ViewBaseComponent implements OnInit {
  @Input()
  booking: Reservierung;

  private baseUrl: string;

  constructor(@Inject('BASE_URL') baseUrl: string, public activeModal: NgbActiveModal, startupService: StartupService, titleService: Title, meta: Meta) {
    super(titleService, startupService, meta);
    this.baseUrl = baseUrl;
  }

  ngOnInit() {
    this.viewState = ComponentStatus.Displaying;
  }

  getBarcodeUrl(): string {
    if (this.booking != null) {
      return this.baseUrl + 'api/Booking/Barcode/' + this.booking.id;
    }
  }
}
